export default "__VITE_ASSET__Q819ekSg__"